

document.addEventListener('DOMContentLoaded', function () {

  const trigger = document.querySelector('.ling_mb_product_media');
  const mb_fixedTop = document.querySelector('.ling_mb_fixed_top');

  const mb_items = document.querySelectorAll('.mb_llingclick');
  console.log("mb_items",mb_items)
  const mb_wrapper = document.querySelector('.ling_mb_top_container');

  if (!mb_items.length || !mb_wrapper || !mb_fixedTop || !trigger) return;

  let mb_html = '';

  // 默认隐藏
  mb_fixedTop.style.display = 'none';

  // 生成导航
  mb_items.forEach((item, index) => {
    const title = item.querySelector('.ling_top_title_click');
    if (!title) return;

    const text = title.textContent.trim();

    mb_html += `
      <div class="ling__mbtop_click_text" data-index="${index}">
        ${text}
      </div>
    `;
  });

  mb_wrapper.insertAdjacentHTML('afterbegin', mb_html);

  const mb_navItems = mb_wrapper.querySelectorAll('.ling__mbtop_click_text');

  // 高亮
  function mb_setActive(index) {
    mb_navItems.forEach((nav, i) => {
      nav.classList.toggle('item_active', i === index);
    });
  }

  // 清空高亮
  function mb_clearActive() {
    mb_navItems.forEach(nav => nav.classList.remove('item_active'));
  }

  // 点击滚动
  mb_navItems.forEach(nav => {
    nav.addEventListener('click', function () {
      const index = this.dataset.index;
      const target = mb_items[index];

      if (!target) return;

      const offset = 0;

      const top =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        offset;

      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    });
  });

  // scroll 事件（优化版）
  window.addEventListener('scroll', function () {
  if (window.innerWidth >= 769) return;

  const triggerRect = trigger.getBoundingClientRect();

  // 显示/隐藏顶部导航
  if (triggerRect.bottom <= 0) {
    mb_fixedTop.style.display = 'block';
  } else {
    mb_fixedTop.style.display = 'none';
  }

  // ⭐ 判断是否在整个模块区域内
  const firstRect = mb_items[0].getBoundingClientRect();
  const lastRect = mb_items[mb_items.length - 1].getBoundingClientRect();

  const inSection =
    lastRect.bottom > 0 && firstRect.top < window.innerHeight;

  if (!inSection) {
    mb_clearActive();
    return;
  }

  // 找最近元素
  let activeIndex = -1;
  let minDistance = Infinity;

  mb_items.forEach((item, index) => {
    const rect = item.getBoundingClientRect();

    const distance = Math.abs(rect.top - 120); // 120更稳定（不是0）

    if (distance < minDistance) {
      minDistance = distance;
      activeIndex = index;
    }
  });

  if (activeIndex !== -1) {
    mb_setActive(activeIndex);
  } else {
    mb_clearActive();
  }
});


      const detailBtn_mb = document.querySelector('.ling_mb_top_click_detail');
      const reviewBtn_mb = document.querySelector('.ling_mb_top_click_pinglun');

      const mainProduct_mb = document.querySelector('.ling_main_product');
      const reviewSection_mb = document.querySelector('#judgeme_product_reviews');

      const stickyHeader_mb = document.querySelector('sticky-header');

      const mainProductHeight_mb = mainProduct_mb ? mainProduct_mb.offsetHeight : 0;
      const stickyHeaderHeight_mb = stickyHeader_mb ? stickyHeader_mb.offsetHeight : 0;

      console.log('mainProduct高度:', mainProductHeight_mb);
      console.log('stickyHeader高度:', stickyHeaderHeight_mb);

      // 点击详情
      if (detailBtn_mb && mainProduct_mb) {
        detailBtn_mb.addEventListener('click', function () {
          const offset_mb = 0;

          const top_mb = mainProductHeight_mb + stickyHeaderHeight_mb - offset_mb;

          window.scrollTo({
            top: top_mb,
            behavior: 'smooth'
          });
        });
      }

      // 点击评论
      if (reviewBtn_mb && reviewSection_mb) {
        reviewBtn_mb.addEventListener('click', function () {
          const offset_mb = 0;

          const top_mb =
            reviewSection_mb.getBoundingClientRect().top +
            window.pageYOffset -
            offset_mb;

          window.scrollTo({
            top: top_mb,
            behavior: 'smooth'
          });
        });
      }

      window.addEventListener('scroll', function () {
        const scrollTop_mb = window.pageYOffset;

        const mainTop_mb = mainProductHeight_mb + stickyHeaderHeight_mb;
        const mainBottom_mb =
          reviewSection_mb.getBoundingClientRect().top + window.pageYOffset;

        const reviewTop_mb = reviewSection_mb.offsetTop;

        // 清空
        detailBtn_mb.classList.remove('item_active');
        reviewBtn_mb.classList.remove('item_active');

        
        // main 区间
        if (scrollTop_mb <= mainTop_mb && scrollTop_mb > mainBottom_mb) {
          return;
        }

        // 详情区
        if (scrollTop_mb >= mainTop_mb && scrollTop_mb < mainBottom_mb) {
          detailBtn_mb.classList.add('item_active');
          
          return;
        }

        // 评论区
        if (scrollTop_mb >= mainBottom_mb) {
          reviewBtn_mb.classList.add('item_active');
          
          return;
        }
      });

            

    });
    

     
     

    class LingSpeand extends HTMLElement {
  connectedCallback() {
    const usePage = this.querySelector('.ling_use_page');
    const moreWrap = this.querySelector('.ling_pc_more');
    const moreBtn = this.querySelector('.ling_pc_border_more');

    if (!usePage || !moreWrap || !moreBtn) return;

    const maxHeight = 919;

    // 初始化
    const init = () => {
      if (usePage.scrollHeight > maxHeight) {
        moreWrap.style.display = 'block';
        usePage.classList.add('ling_limit');
      } else {
        moreWrap.style.display = 'none';
        usePage.classList.remove('ling_limit');
      }
    };

    init();

    moreBtn.addEventListener('click', () => {
      const isActive = moreWrap.classList.contains('ling_zhang_active');

      if (isActive) {
        // 收起
        usePage.classList.add('ling_limit');
        moreWrap.classList.remove('ling_zhang_active');
      } else {
        // 展开
        usePage.classList.remove('ling_limit');
        moreWrap.classList.add('ling_zhang_active');
      }
    });

    window.addEventListener('resize', init);
  }
}

customElements.define('ling-speand', LingSpeand);


class MbSpend extends HTMLElement {
  connectedCallback() {
    const content = this.querySelector('.ling_mb_up_down');
    const moreWrap = this.querySelector('.ling_mb_more');
    const btn = this.querySelector('.ling_mb_border_more');

    if (!content || !moreWrap || !btn) return;

    const maxHeight = 132;

    const init = () => {
      if (content.scrollHeight > maxHeight) {
        moreWrap.style.display = 'block';
        content.classList.add('ling_mb_limit');
      } else {
        moreWrap.style.display = 'none';
        content.classList.remove('ling_mb_limit');
      }
    };

    init();

    btn.addEventListener('click', () => {
      const isOpen = moreWrap.classList.contains('ling_mb_zhang_active');

      if (isOpen) {
        content.classList.add('ling_mb_limit');
        moreWrap.classList.remove('ling_mb_zhang_active');
      } else {
        content.classList.remove('ling_mb_limit');
        moreWrap.classList.add('ling_mb_zhang_active');
      }
    });

    window.addEventListener('resize', init);
  }
}

customElements.define('mb-spend', MbSpend);

class LingMbClick extends HTMLElement {
  connectedCallback() {
    const popup = this.querySelector('.ling_mb_popup_up');
    const closeBtn = this.querySelector('.ling_mb_close');
    const overlay = document.querySelector('.ling_click_olvery');

    if (!popup || !closeBtn || !overlay) return;

    this.addEventListener('click', (e) => {
      const trigger = e.target.closest('.ling_icon_text');
      if (!trigger) return;

      popup.classList.add('ling_show');
      overlay.classList.add('ling_show');

      // 🚀 禁止滚动
      document.body.style.overflowY = 'hidden';
    });

    const close = () => {
      popup.classList.remove('ling_show');
      overlay.classList.remove('ling_show');

      // 🚀 恢复滚动
      document.body.style.overflowY = '';
    };

    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      close();
    });

    overlay.addEventListener('click', close);

    popup.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }
}

customElements.define('ling-mb-click', LingMbClick);


class LingMbUse extends HTMLElement {
  connectedCallback() {
    const trigger = this.querySelector('.ling_mb_use_item');
    const popup = this.querySelector('.ling_use_item_mb');
    const closeBtn = this.querySelector('.ling_close_mb');
    const overlay = document.querySelector('.ling_click_olvery'); // 可选

    if (!trigger || !popup || !closeBtn) return;

    const open = () => {
      popup.classList.add('ling_show');

      if (overlay) overlay.classList.add('ling_show');
      document.body.style.overflowY = 'hidden';
    };

    const close = () => {
      popup.classList.remove('ling_show');

      if (overlay) overlay.classList.remove('ling_show');
      document.body.style.overflowY = '';
    };

    // 打开
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      open();
    });

    // 关闭按钮
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      close();
    });

    // 点击 popup 外部关闭（防止误触）
    popup.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    // 点击遮罩关闭（如果存在）
    if (overlay) {
      overlay.addEventListener('click', close);
    }
  }
}

customElements.define('ling-mb-use', LingMbUse);


class LingSkuDetail extends HTMLElement {
  connectedCallback() {

    const text = this.querySelector('.ling_sku_detail_text');
    const more = this.querySelector('.ling_sku_more');

    if (!text || !more) return;

    // PC / Mobile 高度
    const getMaxHeight = () => {
      return window.innerWidth <= 768 ? 35 : 75;
    };

    // 初始化
    const init = () => {

      const maxHeight = getMaxHeight();

      // 先重置
      text.classList.remove('ling_sku_open');
      text.style.maxHeight = maxHeight + 'px';

      // 判断是否超出
      if (text.scrollHeight > maxHeight) {

        more.style.display = 'flex';
        text.classList.add('ling_sku_limit');

      } else {

        more.style.display = 'none';
        text.classList.remove('ling_sku_limit');
        text.style.maxHeight = 'none';
      }
    };

    init();

    // 点击展开/收起
    more.addEventListener('click', () => {

      const isOpen = text.classList.contains('ling_sku_open');

      if (isOpen) {

        // 收起
        text.classList.remove('ling_sku_open');
        text.style.maxHeight = getMaxHeight() + 'px';

        more.classList.remove('ling_sku_active');

      } else {

        // 展开
        text.classList.add('ling_sku_open');
        text.style.maxHeight = text.scrollHeight + 'px';

        more.classList.add('ling_sku_active');
      }
    });

    // resize重新检测
    window.addEventListener('resize', init);

  }
}
 
customElements.define('ling-sku-detail', LingSkuDetail);


document.addEventListener('DOMContentLoaded', function () {

  const titleEl = document.querySelector('.ling_sku_detail_title');
  const textEl = document.querySelector('.ling_sku_detail_text');

  function renderSkuDetail(value) {

    const data = sku_click_json[value];

    if (!data) return;

    titleEl.innerHTML = data.title || '';

    textEl.innerHTML = '';

    data.text.forEach(item => {
      textEl.innerHTML += `<p>${item}</p>`;
    });
  }

  // 初始默认读取 json 第一个数据
  const firstKey = Object.keys(sku_click_json)[0];

  if (firstKey) {
    renderSkuDetail(firstKey);
  }

  // variant切换时更新
  document.addEventListener('change', function (e) {

    const input = e.target.closest('.variant-cards input');

    if (!input) return;

    renderSkuDetail(input.value);

  });

});






// function initShopifyPriceSystem() {
//   let unitPrice = 0;
//   let saveUnitPrice = 0;

//   const getPriceText = () => {
//     const wrap = document.querySelector('.ling_price_buy .price-item--sale span');
//     return wrap && (wrap.querySelector('.money') || wrap.querySelector('span') || wrap);
//   };

//   const getSavePriceText = () => {
//     const wrap = document.querySelector('.ling_price_buy .product_price__compare span');
//     return wrap && (wrap.querySelector('.money') || wrap.querySelector('span') || wrap);
//   };

//   const getQtyInput = () => {
//     const wrap = document.querySelector('quantity-input');
//     return wrap?.querySelector('input[name="quantity"]');
//   };

//   const getWrap = () => document.querySelector('.ling_price_buy .price-item--sale');
//   const getSaveWrap = () => document.querySelector('.ling_price_buy .product_price__compare');
  
//   const formatPrice = (total) => Shopify.formatMoney(total); // ✅ 修复：补上 return

//   function updatePrice() {
//     const priceText = getPriceText();
//     const savepriceText = getSavePriceText();
//     const qtyInput = getQtyInput();

//     if (!priceText || !savepriceText || !qtyInput) return;

//     const qty = parseInt(qtyInput.value || 1, 10);
//     console.log("priceText)",priceText)
//     console.log("savepriceText)",savepriceText)

//     priceText.innerHTML = formatPrice(unitPrice * qty);       // ✅ 修复：移除无用变量
//     savepriceText.innerHTML = formatPrice(saveUnitPrice * qty);
//   }

//   function syncUnitPrice() {
//     const wrap = getWrap();
//     const saveWrap = getSaveWrap();
//     if (!wrap) return;

//     unitPrice = parseInt(wrap.dataset.unitPrice || 0, 10);
//     saveUnitPrice = parseInt(saveWrap?.dataset.unitPrice || 0, 10);
//   }

//   document.addEventListener('click', (e) => {
//     if (!e.target.closest('[name="minus"]') && !e.target.closest('[name="plus"]')) return;
//     syncUnitPrice();
//     setTimeout(updatePrice, 0);
//   });

//   document.addEventListener('input', (e) => {
//     if (!e.target.matches('quantity-input input[name="quantity"]')) return;
//     updatePrice();
//   });

//   document.addEventListener('variant:change', (e) => {
//     const variant = e.detail?.variant;
//     if (!variant) return;

//     const wrap = getWrap();
//     const saveWrap = getSaveWrap();
//     if (!wrap) return;

//     wrap.dataset.unitPrice = variant.price;
//     saveWrap.dataset.unitPrice = variant.compare_at_price || variant.price;

//     updatePrice();
//   });

//   const observer = new MutationObserver(syncUnitPrice);
//   observer.observe(document.body, { childList: true, subtree: true });

//   syncUnitPrice();
//   updatePrice();
// }

// window.addEventListener('load', () => setTimeout(initShopifyPriceSystem, 300));
